import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  a11yColorScheme: '',
  dirty: false,

  fontSize: 16,
  letterSpacing: 0,
}

export const a11ySlice = createSlice({
  name: 'a11y',
  initialState,
  reducers: {
    setA11yColorScheme: (state, { payload }) => {
      state.a11yColorScheme = payload
      state.dirty = isDirty(state)
    },
    setFontSize: (state, { payload }) => {
      state.fontSize = payload
      state.dirty = isDirty(state)
    },
    setLetterSpacing: (state, { payload }) => {
      state.letterSpacing = payload
      state.dirty = isDirty(state)
    },
    dropA11yState: (state, { payload }) => {
      return initialState
    },
  },
})

const isDirty = (state) => {
  if (
    state.a11yColorScheme === initialState.a11yColorScheme &&
    state.fontSize === initialState.fontSize &&
    state.letterSpacing === initialState.letterSpacing
  ) {
    return false
  }
  return true
}

// Action creators are generated for each case reducer function
export const { setA11yColorScheme, dropA11yState, setFontSize, setLetterSpacing } =
  a11ySlice.actions

export const a11ySelector = (state) => state.a11y
export const a11yReducer = a11ySlice.reducer
